export enum WheelTypeEnum {
    None = 0,
    TwoWheels = 1,
    ThreeWheels = 2,
    FourWheels = 3
}
